import className from "classnames/bind";
import {FontAwesomeIcon} from "~/components";
import {fmt} from "./TechShared";
import style from "../style/Technical.module.scss";

const cn = className.bind(style);

/**
 * Tổng quan kỹ thuật: lưới thẻ chỉ số từ lần crawl mới nhất. Các chỉ số "xấu" (link hỏng,
 * lỗi server, mồ côi...) tô đỏ khi > 0 để nổi bật vấn đề cần xử lý.
 */
function TechSummary({summary}) {

	const cards = [
		{label: 'Trang đã crawl', value: summary.pages, icon: 'fa-light fa-file-lines', color: '#4f46e5'},
		{label: 'Link nội bộ', value: summary.internal_links, icon: 'fa-light fa-link', color: '#4f46e5'},
		{label: 'Link ngoài', value: summary.external_links, icon: 'fa-light fa-arrow-up-right-from-square', color: '#0ea5e9'},
		{label: 'Link nofollow', value: summary.nofollow_links, icon: 'fa-light fa-link-slash', color: '#6b7280'},
		{label: 'Link nội bộ hỏng', value: summary.broken_internal, icon: 'fa-light fa-heart-crack', bad: true},
		{label: 'Link ngoài hỏng', value: summary.broken_external, icon: 'fa-light fa-unlink', bad: true},
		{label: 'Lỗi server (5xx)', value: summary.server_errors, icon: 'fa-light fa-server', bad: true},
		{label: 'Chuyển hướng', value: summary.redirects, icon: 'fa-light fa-arrows-turn-right', color: '#D97706'},
		{label: 'Chuỗi redirect', value: summary.redirect_chains, icon: 'fa-light fa-link', bad: true},
		{label: 'Trang mồ côi', value: summary.orphans, icon: 'fa-light fa-ghost', bad: true},
		{label: 'Trang bị chặn', value: summary.blocked, icon: 'fa-light fa-ban', color: '#6b7280'},
	];

	return (
		<div className={cn('statGrid')}>
			{cards.map((c) => {
				const danger = c.bad && Number(c.value) > 0;
				const color = danger ? '#DC2626' : (c.color || '#16A34A');
				return (
					<div className={cn('statCard', {danger})} key={c.label}>
						<div className={cn('statIcon')} style={{color}}><FontAwesomeIcon icon={c.icon} /></div>
						<div>
							<div className={cn('statValue')} style={{color}}>{fmt(c.value)}</div>
							<div className={cn('statLabel')}>{c.label}</div>
						</div>
					</div>
				);
			})}
		</div>
	);
}

export default TechSummary;
